(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cards = document.querySelectorAll('[data-product-card]');
  if (!cards.length) return;

  const hoverCapable = window.matchMedia('(hover: hover)');

  function inferChipColor(label = '') {
    const value = label.toLowerCase().trim();

    if (value.includes('atomic purple')) return '#a98bdc';
    if (value.includes('lavender')) return '#c7b4ea';
    if (value.includes('purple')) return '#9b7ad9';
    if (value.includes('sky blue')) return '#89ccf1';
    if (value.includes('light blue')) return '#9fd6ff';
    if (value.includes('blue')) return '#61aef2';
    if (value.includes('mint')) return '#b8f0d2';
    if (value.includes('green')) return '#7bd69a';
    if (value.includes('yellow')) return '#f4dd6b';
    if (value.includes('orange')) return '#f4b26b';
    if (value.includes('red')) return '#ef7d7d';
    if (value.includes('pink')) return '#f2a9c6';
    if (value.includes('black')) return '#2f3640';
    if (value.includes('white')) return '#f8fafc';
    if (value.includes('grey') || value.includes('gray')) return '#c7d2de';
    if (value.includes('clear') || value.includes('transparent')) return '#e9eef5';

    return '#d8e4f3';
  }

  function parseVariantData(card) {
    const script = card.querySelector('[data-card-variant-data]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.error('Unable to parse product card variant data', error);
      return {};
    }
  }

  function shouldIgnoreCardNavigation(target) {
    if (!(target instanceof Element)) return true;

    return Boolean(
      target.closest(
        'a, button, input, select, textarea, label, summary, details, [data-card-chip], [data-card-add-button], [data-card-quick-add-form]'
      )
    );
  }

  function openProductUrl(url, event) {
    if (!url) return;

    if (event?.metaKey || event?.ctrlKey) {
      window.open(url, '_blank', 'noopener');
      return;
    }

    window.location.href = url;
  }

  cards.forEach((card) => {
    const mediaWrap = card.querySelector('[data-card-media-wrap]');
    const mediaLink = card.querySelector('.product-card__media');
    const titleLink = card.querySelector('.product-card__title a');
    const productUrl = mediaLink?.getAttribute('href') || titleLink?.getAttribute('href') || '';

    const primaryImage = card.querySelector('.product-card__image--primary');
    const secondaryImage = card.querySelector('.product-card__image--secondary');
    const chips = Array.from(card.querySelectorAll('[data-card-chip]'));
    const hiddenVariantInput = card.querySelector('[data-card-variant-id]');
    const previews = Array.from(card.querySelectorAll('[data-variant-preview]'));
    const quickAddForm = card.querySelector('[data-card-quick-add-form]');
    const quickAddButton = card.querySelector('[data-card-add-button]');
    const quickAddText = quickAddButton ? quickAddButton.querySelector('.product-card__quick-add-text') : null;
    const variantData = parseVariantData(card);

    const hasVariantPreviews = previews.length > 0;
    const hasSecondaryImage = Boolean(secondaryImage);
    const canHoverSwapVariantCard = Boolean(mediaWrap && primaryImage && hasSecondaryImage && hasVariantPreviews);

    let selectedVariantId = hiddenVariantInput ? String(hiddenVariantInput.value) : null;
    let resetTimer = null;

    chips.forEach((chip) => {
      const swatch = chip.querySelector('.product-card__chip-swatch');
      if (!swatch) return;

      swatch.style.setProperty('--chip-color', inferChipColor(chip.dataset.colorLabel || ''));
    });

    function isVariantAvailable(variantId) {
      return Boolean(variantData[String(variantId)]?.available);
    }

    function syncQuickAddState(variantId) {
      if (!quickAddButton || !quickAddText || !variantId) return;

      const available = isVariantAvailable(variantId);

      quickAddButton.disabled = !available;
      quickAddButton.setAttribute('aria-disabled', String(!available));

      if (!quickAddButton.classList.contains('is-loading') && !quickAddButton.classList.contains('is-added')) {
        quickAddText.textContent = available ? 'Add' : 'Sold out';
      }
    }

    function clearCardHoverSecondary() {
      if (!mediaWrap) return;
      mediaWrap.classList.remove('is-card-hover-secondary');
    }

    function showCardHoverSecondary() {
      if (!hoverCapable.matches || !canHoverSwapVariantCard) return;

      mediaWrap.classList.add('is-card-hover-secondary');
      mediaWrap.classList.remove('has-active-variant-preview');

      previews.forEach((preview) => {
        preview.classList.remove('is-active');
      });

      chips.forEach((chip) => {
        const isSelected = String(chip.dataset.variantId) === String(selectedVariantId);
        chip.classList.toggle('is-selected', isSelected);
        chip.setAttribute('aria-pressed', String(isSelected));
      });
    }

    function setActivePreview(variantId, updateSelection = false) {
      clearCardHoverSecondary();

      let hasActivePreview = false;

      previews.forEach((preview) => {
        const isActive = String(preview.dataset.variantPreview) === String(variantId);
        preview.classList.toggle('is-active', isActive);

        if (isActive) {
          hasActivePreview = true;
        }
      });

      if (mediaWrap) {
        mediaWrap.classList.toggle('has-active-variant-preview', hasActivePreview);
      }

      chips.forEach((chip) => {
        const isSelected = String(chip.dataset.variantId) === String(variantId);
        chip.classList.toggle('is-selected', isSelected);
        chip.setAttribute('aria-pressed', String(isSelected));
      });

      if (updateSelection) {
        selectedVariantId = String(variantId);

        if (hiddenVariantInput) {
          hiddenVariantInput.value = variantId;
        }

        syncQuickAddState(variantId);
      }
    }

    function restoreSelectedPreview() {
      clearCardHoverSecondary();

      if (!selectedVariantId) return;
      setActivePreview(selectedVariantId, false);
      syncQuickAddState(selectedVariantId);
    }

    chips.forEach((chip) => {
      const variantId = chip.dataset.variantId;
      if (!variantId) return;

      chip.addEventListener('mouseenter', () => {
        if (!hoverCapable.matches) return;
        setActivePreview(variantId, false);
      });

      chip.addEventListener('mouseleave', () => {
        if (!hoverCapable.matches) return;

        if (card.matches(':hover') && canHoverSwapVariantCard) {
          showCardHoverSecondary();
          return;
        }

        restoreSelectedPreview();
      });

      chip.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (resetTimer) {
          window.clearTimeout(resetTimer);
          resetTimer = null;
        }

        quickAddButton?.classList.remove('is-added');
        quickAddButton?.classList.remove('is-loading');

        setActivePreview(variantId, true);

        if (event.detail > 0) {
          chip.blur();
        }
      });
    });

    if (quickAddButton) {
      quickAddButton.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    if (quickAddForm && quickAddButton && quickAddText) {
      quickAddForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const activeVariantId = hiddenVariantInput ? String(hiddenVariantInput.value) : selectedVariantId;
        if (!activeVariantId) return;

        if (!isVariantAvailable(activeVariantId)) {
          syncQuickAddState(activeVariantId);
          return;
        }

        if (quickAddButton.disabled || quickAddButton.classList.contains('is-loading')) return;

        quickAddButton.classList.remove('is-added');

        if (resetTimer) {
          window.clearTimeout(resetTimer);
          resetTimer = null;
        }

        quickAddButton.classList.add('is-loading');
        quickAddText.textContent = 'Adding…';

        try {
          const formData = new FormData(quickAddForm);

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) {
            let message = 'Unable to add item to cart';

            try {
              const errorData = await response.json();
              message = errorData.description || message;
            } catch (parseError) {
              // keep fallback message
            }

            throw new Error(message);
          }

          quickAddButton.classList.remove('is-loading');
          quickAddButton.classList.add('is-added');
          quickAddText.textContent = 'Added';

          document.dispatchEvent(new Event('cart:refresh-and-burst'));

          resetTimer = window.setTimeout(() => {
            quickAddButton.classList.remove('is-added');
            syncQuickAddState(selectedVariantId);
          }, 1450);
        } catch (error) {
          console.error(error);
          quickAddButton.classList.remove('is-loading');
          quickAddButton.classList.remove('is-added');
          syncQuickAddState(selectedVariantId);
        }
      });
    }

    if (productUrl) {
      card.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;
        if (shouldIgnoreCardNavigation(event.target)) return;

        openProductUrl(productUrl, event);
      });

      card.addEventListener('auxclick', (event) => {
        if (event.button !== 1) return;
        if (event.defaultPrevented) return;
        if (shouldIgnoreCardNavigation(event.target)) return;

        window.open(productUrl, '_blank', 'noopener');
      });
    }

    if (canHoverSwapVariantCard) {
      card.addEventListener('mouseenter', () => {
        if (!hoverCapable.matches) return;
        showCardHoverSecondary();
      });

      card.addEventListener('mouseleave', () => {
        if (!hoverCapable.matches) return;
        restoreSelectedPreview();
      });
    }

    if (selectedVariantId) {
      restoreSelectedPreview();
    }
  });
})();